export { default } from "@vendors/CreativeTim/components/Card/CardFooter.js";
